import axios from 'axios';

import { API_BASE_URL } from '../env';

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Important - sends cookies with every request
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to ensure credentials are sent
api.interceptors.request.use(
  (config) => {
    // Ensure credentials are always included
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Don't redirect on /auth/me or /auth/check - let the components handle it
    const isAuthCheck = error.config?.url?.includes('/auth/me') || 
                       error.config?.url?.includes('/auth/check');
    
    if (error.response?.status === 401 && !isAuthCheck) {
      // Only redirect to login for protected routes, not auth checks
      console.log('Unauthorized - redirecting to login');
      
      // Avoid redirect loop - only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login?error=Please sign in to continue';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
